import React from 'react';
import { useAuth } from '../features/auth/context/AuthContext';
import RecentSessions from '../features/home/components/RecentSessions';
import ActiveEvents from '../features/home/components/ActiveEvents';
import '../features/home/styles/home.css';

export default function HomePage() {
  const { user, userProfile } = useAuth();
  const firstName = userProfile?.firstName || userProfile?.first_name || String(user || '').split('@')[0];
  const today = new Date().toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });

  return (
    <div className="home-dashboard">
      <div className="home-content">
        <div className="home-page-head">
          <h1 className="home-page-title">Welcome back, {firstName}.</h1>
          <p className="home-page-sub">{today}</p>
        </div>

        <div className="home-grid">
          <RecentSessions />
          <ActiveEvents />
        </div>
      </div>
    </div>
  );
}
